module.exports = __webpack_public_path__ + "static/media/wordpress.bd8a08d0.jpg";